import { Button, Tooltip } from '@heroui/react';
import { MoonIcon, SunIcon } from '@heroicons/react/24/solid';
import clsx from 'clsx';
import { useDarkMode } from './hooks/useDarkMode';

export default function DarkModeToggle({ className, size = 'sm' }) {
  const { isDark, toggleTheme } = useDarkMode();

  if (process.env.NODE_ENV === 'production') {
    return null;
  }

  const icon = isDark ? (
    <MoonIcon className="h-4 w-4 text-default-700" />
  ) : (
    <SunIcon className="h-4 w-4 text-amber-500" />
  );

  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';

  return (
    <Tooltip content={label}>
      <Button
        isIconOnly
        variant="light"
        size={size}
        aria-label={label}
        className={clsx(
          'border border-default-200 bg-background/80 text-default-600',
          className
        )}
        onPress={toggleTheme}
      >
        {icon}
      </Button>
    </Tooltip>
  );
}
